<template>
  <div class="kdz-input-container">
    <div class="kdz-input-field">
      <input
        class="w3-check kdz-centered"
        type="checkbox"
        v-model="model"
        v-if="type === 'checkbox'"
      />
      <input
        class="w3-input w3-border"
        type="number"
        min="0"
        v-model="model"
        v-else
      />
      <label class="kdz-centered-vertical" v-html="title"></label>
    </div>
  </div>
</template>

<script>
import { mapMutations, mapGetters } from "vuex";

export default {
  name: "Input",
  props: {
    type: {
      type: String,
      required: true,
    },
    modelName: {
      type: String,
      required: true,
    },
    title: {
      type: String,
      required: true,
    },
  },
  computed: {
    ...mapGetters(["getSelection"]),
    model: {
      get() {
        return this.getSelection[this.modelName];
      },
      set(value) {
        this.updateSelection(this.modelName, value);
      },
    },
  },

  methods: {
    ...mapMutations(["setSelection"]),
    updateSelection(attribute, value) {
      let selected = this.getSelection;
      selected[attribute] = value;
      this.setSelection(selected);
    },
  },
};
</script>

<style lang="scss" scoped>
.kdz-input-field {
  display: grid;
  grid-template-columns: 80px auto;
  gap: 10px;

  input[type=checkbox] {
    height: 24px;
    width: 24px;
    &:checked::before{
      width: 22px;
      line-height: 20px;
    }
  }
  .kdz-centered {
    justify-self: center;
  }
  .kdz-centered-vertical {
    align-self: center;
  }
}
</style>
